<template>
    <div v-if="display">
        <div class="text-success" v-if="currentBundleBookingRule"><i class="fas fa-check-circle"></i> You have activated a bundle booking rule because you booked {{ currentBundleBookingRule.participant_count }} participants; {{ currentBundleBookingRule | displayAdjustment }}</div>
        <div class="text-info" v-if="nextBundleBookingRule"><i class="fa fa-question-circle"></i> If you enter {{ nextBundleBookingRule.participant_count }} participants, {{ nextBundleBookingRule | displayAdjustment }}</div>
    </div>
</template>

<script>
import {displayAdjustment} from "../BundleBookingRules/filters/display_adjustment";

export default {
    name: 'DisplayBundleBookingBenefits',

    props: {
        bundleBooking: {
            required: true,
            type: Object,
        },
        numberOfParticipantsSelected: {
            required: true,
            type: Number,
        },
    },

    filters: {
        displayAdjustment,
    },

    computed: {
        currentBundleBookingRule() {
            return [...this.sortedBundleBookingRules].reverse().find(bundleBookingRule => bundleBookingRule.participant_count <= this.numberOfParticipantsSelected);
        },
        display() {
            return Boolean(this.currentBundleBookingRule || this.nextBundleBookingRule);
        },
        nextBundleBookingRule() {
            return [...this.sortedBundleBookingRules].find(bundleBookingRule => bundleBookingRule.participant_count > this.numberOfParticipantsSelected);
        },
        sortedBundleBookingRules() {
            return [...this.bundleBooking.bundle_booking_rules].sort(function (bundleBookingRule1, bundleBookingRule2) {
                if (bundleBookingRule1.participant_count < bundleBookingRule2.participant_count) {
                    return -1;
                }

                if (bundleBookingRule1.participant_count > bundleBookingRule2.participant_count) {
                    return 1;
                }

                return 0;
            });
        },
    },
}
</script>



// WEBPACK FOOTER //
// src/Assets/components/BundleBookings/DisplayBenefits.vue